export default "__VITE_ASSET__094b0dec__"